export interface MillisecondsToHumanReadableOptions {
  showDecimal?: boolean
  complete?: boolean
  fillWithZero?: boolean
  decimalSize?: number
  withMilliseconds?: boolean
}

export function formatMillisecondsToHumanReadable(
  milliseconds?: number,
  options?: MillisecondsToHumanReadableOptions
) {
  if (!milliseconds) return ''

  function format(value: string, legend: string) {
    const formatted = `${value}${legend}`

    if (options?.complete || !value.match(/^00?$/)) return formatted
    return ''
  }

  function fillWithZero(num: number, legend: string) {
    const returned = num.toString()
    return options?.fillWithZero ? format(returned.padStart(2, '0'), legend) : format(returned, legend)
  }

  let seconds = Math.floor(milliseconds / 1000)
  const secondsDecimal = milliseconds / 1000
  let minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)

  seconds = (options?.showDecimal ? secondsDecimal : seconds) % 60
  seconds = Number.isInteger(seconds) ? seconds : Number(seconds.toFixed(options?.decimalSize ?? 2))
  minutes = minutes % 60

  if (options?.withMilliseconds) {
    const totalSeconds = milliseconds / 1000
    const sec = totalSeconds % 60

    const secondsWithMilliseconds = new Intl.NumberFormat('en-US', {
      style: 'unit',
      unit: 'second',
      unitDisplay: 'narrow',
      maximumFractionDigits: 2,
      signDisplay: 'never',
    }).format(sec)

    if (secondsWithMilliseconds !== '0s')
      return `${fillWithZero(hours, 'h')} ${fillWithZero(minutes, 'm')} ${secondsWithMilliseconds}`
  }

  return `${fillWithZero(hours, 'h')} ${fillWithZero(minutes, 'm')} ${fillWithZero(seconds, 's')}`
}
